import React from 'react';
import './style.css';
import ReactDOM from 'react-dom';
import FullTracker from './components/full_tracker.js'

ReactDOM.render(<FullTracker />, document.getElementById('root'));

var counterContainer = document.querySelector(".visitor-counter");
var visitCount = localStorage.getItem("page_view");

if (visitCount) {
    visitCount = Number(visitCount) + 1;
    localStorage.setItem("page_view", visitCount);
}   else {
    visitCount = 1;
    localStorage.setItem("page_view", 1);
}

counterContainer.innerHTML = visitCount;